module.exports = __webpack_public_path__ + "img/GH-corporate-002sp-new.5a567206.jpg";